export const environment = {
    production: false,
    isExternal: true,
    msalConfig: {
        auth: {
            clientId: 'cce80976-48a9-4fa6-9acf-ec12473ccce0',
            authority: ""
        },
    },
    apiConfig: {
        scopes: ['openid profile offline_access cce80976-48a9-4fa6-9acf-ec12473ccce0'],
        uri: 'https://pplfirstclassicpreprod.onmicrosoft.com/cce80976-48a9-4fa6-9acf-ec12473ccce0/app.user',
    },
    b2cPolicies: {
        names: {
            signUpSignIn: 'B2C_1A_SIGNUP_SIGNIN',
        },
        authorities: {
            signUpSignIn: {
                authority:
                    'https://pplfirstclassicpreprod.b2clogin.com/pplfirstclassicpreprod.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN',
            }
        },
        authorityDomain: 'pplfirstclassicpreprod.b2clogin.com',
    },
    apiUrl: 'https://ngencl-api-pre.pplfirst.com/external-cl',
    mobileHealthUrl: 'https://www.mobilehealth.com/ny-cdpap-ppl-medical-screenings/',
    wotcUrl: 'https://sandbox.wotc.com/portal/public-partnerships-llc-sandbox/f8850?noStartDate=1',
    apimSubScriptionKey: '8d14e48d561a4e4ca0d739a804fcf5fb',
    smartyEmbeddedKey: '215669382422753323',
    isSmartyEnabled: true,
    enableCaliforniaAddressValidation: true,
    restrictedMenus: ["process_codes", "service_codes", "participant_provider_rates", "authorizations", "timesheets"],
    requireAtleastOneUserFilter: true,
    goLiveDate: '2026-07-01',
    showGoLiveBanner: false
};